<template>
  <div class="w-full h-full">
    <div v-if="!hasInternetConnection" class="flex flex-1 items-center content-center">
      <div class="m-auto w-full max-w-xs">
        <div class="text-center font-bold">
          <p class="mb-3">
            Не е налична интернет връзка! <br>
            Не можете да се идентифицирате в системата!
          </p>
          <button
          class="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          type="button"
          @click="checkForInternet"
          >
            Провери за интернет връзка!
          </button>
        </div>
      </div>
    </div>

    <template v-else>
      <div class="flex h-full w-full items-center contrast-light-500">
        <div class="m-auto max-w-xs w-full overflow-y-auto">
          <h1 class="mb-3 text-center font-bold text-2xl">Вход:</h1>
          <div class="mb-2 text-xs text-red-600 text-center" v-if="authenticationErrorCode">
            {{authenticationError}}
          </div>
          <form class="contrast-dark-400 shadow-md rounded px-8 pt-6 pb-8 mb-4" autocomplete="on" v-on:submit.stop.prevent="handleSubmit">
            <div class="mb-4">
              <input
              class="underlined_input"
              type="email"
              name="email"
              id="email"
              placeholder="Email"
              v-model="email"
              autocomplete="email"
              >
<!--              <p class="text-red-500 text-xs italic">{{ errors.first('email') }}</p>-->
            </div>
            <div class="mb-6">
              <input class="underlined_input" type="password" name="password" placeholder="Парола" v-model="password" autocomplete="current-password">
<!--              <p class="text-red-500 text-xs italic">{{ errors.first('password') }}</p>-->
            </div>
            <!-- <div class="flex items-center justify-between"> -->
            <div class="m-auto w-full ">
              <button class="btn btn-primary w-full" type="submit">
                Вход
              </button>
             <!--  <a class="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800" href="#">
                Забравена парола?
              </a> -->
            </div>
          </form>
          <p class="text-center text-gray-500 text-xs">
            &copy;{{new Date().getFullYear()}} Neopharm LTD. All rights reserved.
          </p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ConnectionService from '@/services/connection.service'
export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
    };
  },
  computed: {
      ...mapGetters('auth', [
          'authenticating',
          'authenticationError',
          'authenticationErrorCode'
      ]),
      ...mapGetters(['hasInternetConnection'])
  },
  methods: {
      ...mapActions('auth', [
          'login'
      ]),
      handleSubmit() {
          // Perform a simple validation that email and password have been typed in
          //TODO
          let valid=true;
          if (valid) {
            this.login({email: this.email, password: this.password})
          }
      },
      checkForInternet(){
        ConnectionService.handleConnection();
      }
  }
};
</script>
